import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable, of } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';

export const authGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const auth = inject(AuthService);
  const router = inject(Router);

  // FIX: Create observables from all needed signals at the start,
  // while still in the injection context.
  const isAuthReady$ = toObservable(auth.isAuthReady);
  const appUser$ = toObservable(auth.appUser);

  // Start the chain with the isAuthReady observable
  return isAuthReady$.pipe(
    // 1. Wait until Firebase Auth has initialized
    filter((ready) => ready === true),
    take(1), // Ensure this part of the stream completes
    switchMap(() => {
      // 2. Once ready, check if the user is logged in
      if (!auth.isLoggedIn()) {
        // If not, return an observable of a UrlTree to redirect
        return of(router.createUrlTree(['/auth/login']));
      }

      // 3. If logged in, switch to the pre-created appUser$ observable
      return appUser$.pipe(
        filter((user) => user !== undefined), // Wait until the user object is not undefined
        take(1), // Ensure this part completes
        map(() => true) // Once appUser is loaded, grant access
      );
    })
  );
};
